import { JsonLd } from './JsonLd';
import { SITE_URL, ORG_REFERENCE } from './constants';

// path is the CANONICAL prep URL per license. /lcsw + /lmsw were retired to a
// 301 → /, so their CourseInstance points at the homepage (which now targets all
// three licenses); only /lbsw remains a real landing page.
const LICENSES: ReadonlyArray<{ code: string; label: string; path: string }> = [
  { code: 'LBSW', label: 'Bachelors', path: '/lbsw' },
  { code: 'LMSW', label: 'Masters', path: '/' },
  { code: 'LCSW', label: 'Clinical', path: '/' },
];

/**
 * Course JSON-LD for ASWB exam prep, provided by the Organization (by @id),
 * with one online, self-paced CourseInstance per social work license.
 */
export function buildCourseSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: 'ASWB Social Work Licensing Exam Prep',
    description:
      'Adaptive preparation for the ASWB social work licensing exams (LBSW, LMSW, and LCSW), built around practice questions reviewed by a Licensed Clinical Social Worker.',
    provider: { ...ORG_REFERENCE },
    hasCourseInstance: LICENSES.map(({ code, label, path }) => ({
      '@type': 'CourseInstance',
      name: `${code} Exam Prep`,
      description: `Adaptive practice and analytics for the ASWB ${label} (${code}) social work licensing exam.`,
      courseMode: 'online',
      courseWorkload: 'P1M',
      url: `${SITE_URL}${path}`,
    })),
  };
}

export function CourseSchema() {
  return <JsonLd data={buildCourseSchema()} />;
}
